import React from "react";

const TotalMentorsIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2 28.09L12.7 20.59H2.70001L5.20001 28.09H15.2ZM15.2 28.09H20.2M15.2 16.84V16.215C15.2 13.8575 15.2 12.68 14.4675 11.9475C13.735 11.215 12.5575 11.215 10.2 11.215C7.84251 11.215 6.66501 11.215 5.93251 11.9475C5.20001 12.68 5.20001 13.8575 5.20001 16.215V16.84M17.7 22.465H25.2C25.8631 22.465 26.4989 22.7284 26.9678 23.1972C27.4366 23.6661 27.7 24.302 27.7 24.965V25.59C27.7 26.253 27.4366 26.8889 26.9678 27.3578C26.4989 27.8266 25.8631 28.09 25.2 28.09H23.95M23.95 16.84C23.95 17.503 23.6866 18.1389 23.2178 18.6078C22.7489 19.0766 22.1131 19.34 21.45 19.34C20.787 19.34 20.1511 19.0766 19.6822 18.6078C19.2134 18.1389 18.95 17.503 18.95 16.84C18.95 16.177 19.2134 15.5411 19.6822 15.0722C20.1511 14.6034 20.787 14.34 21.45 14.34C22.1131 14.34 22.7489 14.6034 23.2178 15.0722C23.6866 15.5411 23.95 16.177 23.95 16.84ZM12.7 5.59C12.7 6.25304 12.4366 6.88892 11.9678 7.35776C11.4989 7.8266 10.8631 8.09 10.2 8.09C9.53697 8.09 8.90109 7.8266 8.43225 7.35776C7.9634 6.88892 7.70001 6.25304 7.70001 5.59C7.70001 4.92696 7.9634 4.29107 8.43225 3.82223C8.90109 3.35339 9.53697 3.09 10.2 3.09C10.8631 3.09 11.4989 3.35339 11.9678 3.82223C12.4366 4.29107 12.7 4.92696 12.7 5.59Z"
        stroke="#9BA6B7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TotalMentorsIcon;
